export const initScrollAnimations = () => {
    // Options for the Intersection Observer
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: '0px',
      threshold: 0.15 // Trigger when at least 15% of the element is visible
    };
    
    // Set up the observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Get animation type from data attribute
          const animationType = entry.target.dataset.scroll || 'fade-in-up';
          
          // Add the animation class
          entry.target.classList.add(`animate-${animationType}`);
          
          // Unobserve after animation is applied if once attribute is present
          if (entry.target.hasAttribute('data-scroll-once')) {
            observer.unobserve(entry.target);
          }
        } else if (!entry.target.hasAttribute('data-scroll-once')) {
          // Remove animation class when element leaves viewport (if not once)
          const animationType = entry.target.dataset.scroll || 'fade-in-up';
          entry.target.classList.remove(`animate-${animationType}`);
          entry.target.style.opacity = '0';
        }
      });
    }, options);
    
    // Find all elements with data-scroll attribute
    const scrollElements = document.querySelectorAll('[data-scroll]');
    
    // Set initial opacity
    scrollElements.forEach(el => {
      el.style.opacity = '0';
    });
    
    // Observe all elements with data-scroll attribute
    scrollElements.forEach(el => {
      observer.observe(el);
    });
    
    return observer; // Return observer for cleanup
  };
  
  /**
   * Add hover animations to elements with data-hover attribute
   */
  export const initHoverAnimations = () => {
    const hoverElements = document.querySelectorAll('[data-hover]');
    
    hoverElements.forEach(el => {
      const hoverEffect = el.dataset.hover;
      
      el.addEventListener('mouseenter', () => {
        switch(hoverEffect) {
          case 'lift':
            el.classList.add('transform', 'translate-y-neg-4', 'shadow-lg');
            break;
          case 'scale':
            el.classList.add('transform', 'scale-105');
            break;
          case 'glow':
            el.classList.add('shadow-lg', 'shadow-primary-light');
            break;
          case 'bright':
            el.classList.add('brightness-110');
            break;
          default:
            // Default is lift effect
            el.classList.add('transform', 'translate-y-neg-2', 'shadow-md');
        }
      });
      
      el.addEventListener('mouseleave', () => {
        switch(hoverEffect) {
          case 'lift':
            el.classList.remove('transform', 'translate-y-neg-4', 'shadow-lg');
            break;
          case 'scale':
            el.classList.remove('transform', 'scale-105');
            break;
          case 'glow':
            el.classList.remove('shadow-lg', 'shadow-primary-light');
            break;
          case 'bright':
            el.classList.remove('brightness-110');
            break;
          default:
            // Default is lift effect
            el.classList.remove('transform', 'translate-y-neg-2', 'shadow-md');
        }
      });
    });
  };
  
  /**
   * Initialize both scroll and hover animations
   */
  export const initAllAnimations = () => {
    const scrollObserver = initScrollAnimations();
    initHoverAnimations();
    
    // Return cleanup function
    return () => {
      if (scrollObserver) {
        scrollObserver.disconnect();
      }
    };
  };